var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 12,
    viewBox: "0 0 12 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "m5.076 8.823-3.9-3.922a.606.606 0 0 1 0-.854l.848-.853a.6.6 0 0 1 .849 0L5.5 5.836l5.627-5.66a.6.6 0 0 1 .849 0l.848.854a.606.606 0 0 1 0 .854l-6.9 6.94a.6.6 0 0 1-.848 0"
  })));
};
export default SvgTick;